import React, { Component } from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';

import ProgressIndicator from '../../Components/ProgressIndicator';
import { GlobalContext } from '../../Context/Global.context';

import API, {
    GetOrganizationSecuritySettingsPathForApi,
} from '../../Util/api';

const styles = theme => ({
    contentContainer: {
        background: theme.palette.background.paper,
        padding: theme.spacing(3),
        height: "100%",
        overflowY: "auto",
    },
});

class OrganizationSecurity extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            MFARequired: false,
            ShowProgressIndicatorImmediately: true,
            ShowConfirmDialog: false,
            PendingMFARequired: false,
        };
    }

    componentDidMount() {
        this.loadSecuritySettings();
    }

    loadSecuritySettings = () => {
        this.setState({ ShowProgressIndicatorImmediately: true });
        API.get(GetOrganizationSecuritySettingsPathForApi(this.props.organizationId))
            .then(resp => {
                this.setState({
                    MFARequired: resp.data.MFARequired || false,
                    ShowProgressIndicatorImmediately: false,
                });
            })
            .catch(err => {
                this.setState({ ShowProgressIndicatorImmediately: false });
                if (this.props.onApiError) {
                    this.props.onApiError(err);
                }
            });
    }

    handleMFAToggle = (event) => {
        const newValue = event.target.checked;
        // Show confirmation dialog before changing
        this.setState({
            ShowConfirmDialog: true,
            PendingMFARequired: newValue,
        });
    }

    handleConfirmChange = () => {
        const { PendingMFARequired } = this.state;
        this.setState({
            ShowConfirmDialog: false,
            ShowProgressIndicatorImmediately: true,
        });

        API.put(GetOrganizationSecuritySettingsPathForApi(this.props.organizationId), {
            MFARequired: PendingMFARequired,
        })
            .then(() => {
                this.setState({
                    MFARequired: PendingMFARequired,
                    ShowProgressIndicatorImmediately: false,
                });
            })
            .catch(err => {
                this.setState({ ShowProgressIndicatorImmediately: false });
                if (this.props.onApiError) {
                    this.props.onApiError(err);
                }
            });
    }

    handleCancelChange = () => {
        this.setState({ ShowConfirmDialog: false });
    }

    render() {
        const { classes } = this.props;
        const {
            MFARequired,
            ShowProgressIndicatorImmediately,
            ShowConfirmDialog,
            PendingMFARequired,
        } = this.state;

        return (
            <Container maxWidth="sm" className={classes.contentContainer}>
                <Grid container spacing={3} direction="column">
                    <Grid item>
                        <Typography variant="h6">
                            Security Settings
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="subtitle1" gutterBottom>
                            Multi-Factor Authentication
                        </Typography>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                            When enabled, all organization members will be required to set up
                            an authenticator app (TOTP) before they can access the application.
                        </Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={MFARequired}
                                    onChange={this.handleMFAToggle}
                                    color="primary"
                                />
                            }
                            label={MFARequired ? "MFA required for all members" : "MFA not required"}
                        />
                    </Grid>
                </Grid>

                <Dialog open={ShowConfirmDialog} onClose={this.handleCancelChange} maxWidth="xs" fullWidth>
                    <DialogTitle>
                        {PendingMFARequired ? 'Require MFA?' : 'Disable MFA Requirement?'}
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body2">
                            {PendingMFARequired
                                ? 'All organization members will be required to set up multi-factor authentication before they can access the application. Members who have not yet enrolled will be prompted to do so on their next sign-in.'
                                : 'Organization members will no longer be required to have multi-factor authentication enabled. Members who have already enrolled will keep their MFA active.'}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancelChange}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleConfirmChange}
                        >
                            {PendingMFARequired ? 'Enable Requirement' : 'Disable Requirement'}
                        </Button>
                    </DialogActions>
                </Dialog>

                {ShowProgressIndicatorImmediately && <ProgressIndicator />}
            </Container>
        );
    }
}

export default withStyles(styles)(OrganizationSecurity);
